import { findInArray, FindInArrayResult } from 'owa-calendar-data-utils/lib/findInArray';
import { getStore } from '../store/store';
import { CalendarEntry } from 'owa-graph-schema';

export function findSelectedCalendar(calendarId: string): FindInArrayResult<CalendarEntry> {
    return findInArray(
        getStore().selectedCalendars,
        cal => !!cal.calendarId && cal.calendarId.id == calendarId
    );
}
